import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/locations')({
  beforeLoad: ({ context, params }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('locations:list')) {
      throw redirect({ params: { territoryId: params.territoryId }, to: '/settings/territories/$territoryId' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/locations/pages/territory-locations-page').then((m) => ({
      default: m.TerritoryLocationsPage,
    })),
  ),
  staticData: { titleKey: 'locations' },
});
